import { authMiddleware } from './authMiddleware';

export const Middlewares = {
    Auth: authMiddleware
};
